import axios from "axios";

const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;

/**
 * 반품관리 상태값 개수 가져오기
 * @param param
 * userId
 * @returns {Promise<never>}
 */
const readReturnSummary = async (param) => {
  const { data } = await axios.get(`${baseUrl}/userOrder/summary/return`, {
    params: param,
  });
  return data;
};

/**
 * 단건 DB 결제 정보 찾기
 * @param param
 * user_id, order_id
 * @returns {Promise<never>}
 */
const getPaymentSearchResult = async (param) => {
  const { data } = await axios.get(`${baseUrl}/payment/payment/searchResult`, {
    params: param,
  });
  return data;
};

/**
 * 반품 관련 주문 목록 정보 조회 (2023.07.21) - ksb
 * 1. 기타 반품비용 합계 조회
 * @param param
 * orderId, orderDetailId, userId
 * @returns {Promise<never>}
 */
const getEtcReturnPriceSum = async (param) => {
  const { data } = await axios.get(`${baseUrl}/userOrder/list/return`, {
    params: param,
  });
  return data;
};

/**
 * 반송장 번호 입력
 * @param param
 * @returns {Promise<*>}
 */
const postTrackingNumber = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/userOrder/return/register/trackingNum`,
    param,
  );
  return data;
};

/**
 * 추가 반품비용 청구 (2023.07.21) - ksb
 * @param param
 * @returns {Promise<*>}
 */
const postEtcReturnPrice = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/userOrder/return/edit/etcReturnPrice`,
    param,
  );
  return data;
};

/**
 * 환불 절차 진행
 * @param param
 * @returns {Promise<*>}
 */
const postReturnPortOne = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/payment/payment/cancel/return`,
    param,
  );
  return data;
};

/**
 * 포인트 사용 취소
 * @param param
 * totalOrder: {
 *  id: totalOrder 아이디
 * }
 * @returns {Promise<*>}
 */
const postPointCancel = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/point/point/purchase/cancel`,
    param,
  );
  return data;
};

/**
 * 쿠폰 사용 취소
 * @param param
 * couponIdList, user_coupon_is_available, created_by, user_id
 * @returns {Promise<*>}
 */
const postCouponCancel = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/userCouponCart/changeAvailable`,
    param,
  );
  return data;
};

const ReturnApi = {
  readReturnSummary,
  getPaymentSearchResult,
  getEtcReturnPriceSum,
  postTrackingNumber,
  postEtcReturnPrice,
  postReturnPortOne,
  postPointCancel,
  postCouponCancel,
};

export default ReturnApi;
